import {useQuery} from '@tanstack/react-query';

import {TRUSTPILOT_RATING_QUERY_KEY} from 'constants/trustpilot';

import {fetchTrustpilotRating} from './helpers/helpers';
import {TrustpilotDataType} from './types/types';

/**
 * a hook for getting data for trustpilot
 * @returns {TrustpilotDataType} data for trustpilot and status of getting data
 */
export const useTrustpilotData = (): TrustpilotDataType => {
    const {
        data: trustpilotRating,
        isError,
        isLoading,
    } = useQuery({
        queryFn: fetchTrustpilotRating,
        queryKey: [TRUSTPILOT_RATING_QUERY_KEY],
        staleTime: 300000,
    });

    return {isError, isLoading, trustpilotRating};
};
